<script>

import {mapActions} from "vuex";
import {regexPatterns} from "../../../utils/utils";
import UConnectCheckUserDialog from "./steps/uConnectCheckUserDialog.vue";

export default {
  name: "uConnectDirectRegistration",
  components: {UConnectCheckUserDialog},
  data() {
    return {
      emailError: false,
      email: "",
      alertDialogVisible: false,
      dialogBoxMessage: "",
      dialogBoxTitle: "",
      userTypeErrorCode: 0,
      loading: false,
      requestUConnectForm: {
        email: "",
      },
      rules: {
        email: {
          required: true,
          message: "Please enter a correct email",
          trigger: "blur",
          pattern: regexPatterns.email
        },
      }
    }
  },
  methods: {
    ...mapActions("uConnect", ["checkUConnectUser", "updateUConnectUserPackageDetails"]),
    validateField(field) {
      this.$refs.requestToJoinForm.validateField(field);
    },
    checkUserAndCreate(formName) {

      console.log("checkUserAndCreate");
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.loading) return;
          this.loading = true;

      this.checkUConnectUser({
        params: {
          email: this.requestUConnectForm.email,
        },
            callback: this.checkUConnectUserCallback
          });
        }
      });
    },
    checkUConnectUserCallback(res) {
      console.log("checkUConnectUserCallback");
      console.log("checkUConnectUserCallback: ", res);
      if (res.data.code === 60001 || res.data.code === 60002) {

        localStorage.setItem("uConnectRegistrationKey", res.data.data.uConnectRegistrationKey);
        this.$store.commit("uConnect/updateUserDetails", {
          user: {
            email: res.data.data.user.email,
            userId: res.data.data.user.userId
          }
        });
        this.setFreeTirePackage();


      } else if (res.data.code === 70000) {
        this.alertDialogVisible = true;
        this.dialogBoxMessage = res.data.message;
        this.userTypeErrorCode = res.data.code;
        this.dialogBoxTitle = "User Account Exists"
        this.loading = false;
      }

    },
    //Set Selected as Free Tier
    setFreeTirePackage() {
      console.log("setFreeTirePackage");

      var uConnectRegistrationKey = localStorage.getItem("uConnectRegistrationKey");
      const params = {
        userId: this.$store.state.uConnect.userId,
        email: this.$store.state.uConnect.email,
        uConnectRegistrationKey: uConnectRegistrationKey,
        subscriptionUConnectId: 1
      }
      console.log("params-PD***************", params);
      this.updateUConnectUserPackageDetails({ params, callback: this.updateUConnectUserPackageDetailsCallback })
    },
    updateUConnectUserPackageDetailsCallback(res) {
      console.log("updateUConnectUserPackageDetailsCallback*****", res);

      if (res.data.code == 0) {

        this.$store.commit("uConnect/updateSubscribedUConnectId", {
          subscribedUConnectId: res.data.data.user.uconnectSubscriptionId,
        });

        this.$store.commit("uConnect/updateSubscribedUConnectProductCode", {
          subscribedUConnectProductCode : res.data.data.selectedSubscriptionCode,
        });

        this.$router.push({name:"uConnectSetPasswordStep"});
      }
    },
    handleCloseRegisterDialog() {
      this.alertDialogVisible = false;
      this.clearUserDetails();

    },
    clearUserDetails() {
      this.requestUConnectForm.email = "";
    },
    goToUConnect() {
      // this will automatically go to the search page,if they are logged in. if they aren't logged in, the page will automatically redirect to the log in page
      window.open(
          `${process.env.VUE_APP_UNIFI_AGENT}#/uconnect/search/results`
      );

    },
  }

}
</script>

<template>

  <el-row style="display: flex; align-items: center">
    <el-col :span="24">
      <div class="promo-container">
        <el-row :gutter="20">
          <el-col :span="24">
            <h1 style="font-size: 2vh">Ideal for real estate professionals, mortgage brokers, accountants, migration agents, and related businesses looking to present new property opportunities to their clients
            </h1>
          </el-col>
<!--          <el-col :span="24">-->
<!--            <p class="subtitle">Access exclusive off-the-plan properties and unlock new revenue opportunities.</p>-->
<!--          </el-col>-->
          <el-col :span="24">
<!--            <el-row :gutter="20" style="margin-top: 20px">-->
<!--              &lt;!&ndash;            <el-card >&ndash;&gt;-->
<!--              <el-form-->
<!--                ref="requestAgentForm"-->
<!--                :model="requestUConnectForm"-->
<!--                :rules="rules"-->
<!--                label-position="top"-->
<!--                label-width="100px"-->
<!--                @submit.native.prevent-->
<!--                style="font-family: DINosaur-a, sans-serif;">-->
<!--                <el-row>-->
<!--                  <el-col :span="24">-->
<!--                    <el-form-item prop="email">-->
<!--                      <el-input-->
<!--                        v-model="requestUConnectForm.email"-->
<!--                        maxlength="100"-->
<!--                        placeholder="Your email"-->
<!--                      ></el-input>-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--                  <el-col :span="24">-->
<!--                    <el-form-item style="text-align:center">-->
<!--                      <el-button class="join-btn" @click="checkUserAndCreate('requestAgentForm')">-->
<!--                        Start for free-->
<!--                        <i v-if="loading" class="el-icon-loading"></i>-->
<!--                      </el-button>-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--                </el-row>-->
<!--              </el-form>-->
<!--            </el-row>-->
            <el-row :gutter="20">
              <el-col :span="24">
                <el-divider class="divider-wrapper"> Already have an Account? </el-divider>
                <el-button
                  type="primary"
                  size="large"
                  class="sign-in-btn"
                  @click="goToUConnect"
                >
                  SIGN IN
                </el-button>
              </el-col>
            </el-row>
          </el-col>

        </el-row>
      </div>


      <u-connect-check-user-dialog
          v-if="alertDialogVisible"
          :alertDialogVisible="alertDialogVisible"
          :dialogBoxTitle="dialogBoxTitle"
          :dialogBoxMessage="dialogBoxMessage"
          :userTypeErrorCode="userTypeErrorCode"
          @onClose="handleCloseRegisterDialog"/>
    </el-col>
  </el-row>

</template>

<style scoped>
.promo-container {
  font-family: 'Arial', sans-serif;
  margin: 0 auto;
  padding: 40px;
  text-align: center;
  background-color: #003333;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

h1 {
  color: #ffffff;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 20px;
  line-height: 1.3;
}

.subtitle {
  color: #ffffff;
  font-size: 18px;
  margin-bottom: 30px;
}


.sign-in-btn, .join-btn {
  width: 100%;
  background-color: #ffffff;
  border-color: #ffffff;
  border-radius: 5px;
  padding: 15px 0;
  height: max-content;
  font: 500 14px DINosaur-a, sans-serif;
  color: #003333;
}
.el-divider__text {
  color: #ffffff !important;
  background-color: #003333 !important;
}




</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/uConnectDirectRegistration.vue